export default __webpack_public_path__ + "b205c61bdc057b4afa9fb6863144651d.png";